<template>
  <div class="box">
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">市场调查</div>
      <div class="t-t2box">
        <div class="t-t2">实时倾听客户心声 精准把脉业务短板</div>
      </div>
    </div>

    <!-- 第一部分 -->
    <div class="row1">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">运营管理模式的带来的企业价值</div>
        <div class="t2">打造企业管理终极利器</div>
      </div>

      <!-- row2内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <img src="@/image/products/qiye/tu2@2x.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">效益</div>
              <div class="line"></div>
              <div class="t2">营收目标实现，成本费用 受控，利润有保障</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/qiye/tu3@2x.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">管理</div>
              <div class="line"></div>
              <div class="t2">高效高质量的管理机制形成，重大 项目有突破，日常工作有效率</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/qiye/tu4@2x.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">执行力</div>
              <div class="line"></div>
              <div class="t2">有汇报，有指导，有监督，保障目标 达成和计划执行</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/products/qiye/tu5@2x.png" alt="" />
          <div class="yy">
            <div class="tbox">
              <div class="t1">士气</div>
              <div class="line"></div>
              <div class="t2">奖优罚劣，主动复制，建立正向积 极文化，提升整体氛围</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二部分 -->
    <div class="row2">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">我们的优势</div>
        <br />
        <!-- <div class="t2">专业高效</div> -->
      </div>

      <!-- 内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <img src="@/image/home/juxin.png" alt="" />

          <div class="t1">专业团队</div>
          <div class="t2">专业团队，一对一服务 2000+企业共同选择一致好评</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/home/juxin.png" alt="" />

          <div class="t1">提供地址</div>
          <div class="t2">可为您提供各种地址证明 为您节省创业成本</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/home/juxin.png" alt="" />

          <div class="t1">资深会计团队</div>
          <div class="t2">资深会计团队与业务团队 从业经验5年以上</div>
        </div>

        <div class="r2-tiem">
          <img src="@/image/home/juxin.png" alt="" />

          <div class="t1">安全保障</div>
          <div class="t2">价格透明，资料完全保密 避免泄露</div>
        </div>
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">仅需4步快速注册 全程代办</div>
        <br />
        <div class="t2">摆脱繁琐 让创业简单</div>
      </div>

      <!-- 内容 -->
      <div class="box2">
        <div class="r2-tiem">
          <div class="t1" style="background-color: #0594fe">1</div>
          <div class="t2box">
            <img src="@/image/products/shangwu/tubiao1.png" alt="" />

            <div class="tbbox">
              <div class="tb1">公司核名</div>
              <div class="tb2">2-3个工作日</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <div class="t1" style="background-color: #ff5197">2</div>
          <div class="t2box">
            <img src="@/image/products/shangwu/tubiao2.png" alt="" />

            <div class="tbbox">
              <div class="tb1">登记注册</div>
              <div class="tb2">5-7个工作日</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <div class="t1" style="background-color: #ffc13b">3</div>
          <div class="t2box">
            <img src="@/image/products/shangwu/tubiao3.png" alt="" />

            <div class="tbbox">
              <div class="tb1">领取执照</div>
              <div class="tb2">1个工作日</div>
            </div>
          </div>
        </div>

        <div class="r2-tiem">
          <div class="t1" style="background-color: #38d0f1">4</div>
          <div class="t2box">
            <img src="@/image/products/shangwu/tubiao4.png" alt="" />

            <div class="tbbox">
              <div class="tb1">完成刻章</div>
              <div class="tb2">1-2个工作日</div>
            </div>
          </div>
        </div>
      </div>

      <div class="zixun" @click="goBto">立即咨询</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConstProduct',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/products/bj@2x.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}
//第一部分
.row1 {
  height: 750px;
  overflow: hidden;

  background-color: #ffffff;
  position: relative;

  .title {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 120px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 110px auto;
    justify-content: space-around;

    .r2-tiem {
      height: 363px;
      width: 285px;
      position: relative;

      border-radius: 6px;
      padding: 0;

      img {
        position: absolute;
        top: -14px;
        left: -14px;
        width: 110%;
        height: 110%;
      }

      .yy {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        background-color: rgba($color: #000000, $alpha: 0.2);
        .tbox {
          position: absolute;
          bottom: 0;
          color: #fff;
          overflow: hidden;
        }

        .t1 {
          font-size: 28px;
          height: 28px;
          width: 100%;
          text-align: center;
          margin-bottom: 20px;
          letter-spacing: 1px;
        }
        .line {
          height: 3px;
          width: 32px;
          background-color: #ffffff;
          margin: 0px auto 18px auto;
        }
        .t2 {
          width: 74%;
          font-size: 14px;
          margin: 0 auto;
          text-align: center;
          margin-bottom: 35px;
          font-weight: 300;
        }
      }
    }
  }
}

.row2 {
  height: 700px;
  overflow: hidden;

  background-color: #f7f8fb;
  position: relative;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 110px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 150px auto;
    justify-content: space-around;

    .r2-tiem {
      background-color: #ffffff;
      height: 180px;
      width: 260px;
      position: relative;
      border-radius: 6px;

      img {
        position: absolute;
        top: 0%;
        height: 45px;
        width: 100%;
      }
      .t1 {
        position: absolute;
        top: 10px;
        color: #fff;
        font-size: 20px;
        left: 10px;
      }
      .t2 {
        font-size: 16px;
        margin: 80px auto 0 auto;
        width: 65%;
        color: #333333;
        // text-align: center;
      }
    }
  }

  .zixun {
    // position: absolute;
    letter-spacing: 1px;
    bottom: 100px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
    margin: 180px auto;
  }
}

.row3 {
  height: 720px;
  overflow: hidden;

  background-color: #fff;
  position: relative;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 110px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  // 内容
  .box2 {
    display: flex;

    width: 1300px;
    margin: 120px auto;
    justify-content: space-around;

    .r2-tiem {
      background-color: #ffffff;
      height: 260px;
      width: 285px;
      position: relative;
      border-radius: 6px;

      .t1 {
        position: absolute;
        top: 10px;
        color: #fff;
        font-size: 20px;
        left: 115px;
        width: 54px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        border-radius: 50%;
        // background-color: #0594fe;
      }
      .t2box {
        position: absolute;
        bottom: 0;
        // font-size: 16px;
        width: 100%;
        height: 120px;
        box-shadow: 0px 0px 10px 3px #efefef;
        color: #333333;
        display: flex;
        align-items: center;
        img {
          margin: 0 25px;
          width: 40px;
          height: 40px;
        }

        .tbbox {
          .tb1 {
            font-size: 20px;
            margin-bottom: 10px;
            font-weight: 500;
          }
          .tb2 {
            font-style: 16px;
            font-weight: 200;
          }
        }
      }
    }
  }

  .zixun {
    // position: absolute;
    letter-spacing: 1px;
    bottom: 120px;
    width: 170px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    color: #fff;
    border-radius: 2px;
    margin: 150px auto;
  }
}
</style>
